import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import type { ComponentProps, HTMLAttributes } from "react";

/** 基于 Radix 的 shadcn/ui 对话框根节点。 */
export function Dialog(props: ComponentProps<typeof DialogPrimitive.Root>) {
  return <DialogPrimitive.Root data-slot="dialog" {...props} />;
}

/** 对话框关闭触发器。 */
export function DialogClose(props: ComponentProps<typeof DialogPrimitive.Close>) {
  return <DialogPrimitive.Close data-slot="dialog-close" {...props} />;
}

/** 带 Portal、遮罩、焦点管理与关闭按钮的对话框内容。 */
export function DialogContent({ className = "", children, showCloseButton = true, ...props }: ComponentProps<typeof DialogPrimitive.Content> & { showCloseButton?: boolean }) {
  return <DialogPrimitive.Portal>
    <DialogPrimitive.Overlay data-slot="dialog-overlay" className="fm-shadcn-dialog-overlay" />
    <DialogPrimitive.Content data-slot="dialog-content" className={`fm-shadcn-dialog-content ${className}`.trim()} {...props}>
      {showCloseButton ? <DialogPrimitive.Close className="fm-shadcn-dialog-close" aria-label="关闭"><X aria-hidden="true" /></DialogPrimitive.Close> : null}
      {children}
    </DialogPrimitive.Content>
  </DialogPrimitive.Portal>;
}

/** 对话框标题区域。 */
export function DialogHeader({ className = "", ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div data-slot="dialog-header" className={`fm-shadcn-dialog-header ${className}`.trim()} {...props} />;
}

/** 对话框操作区域。 */
export function DialogFooter({ className = "", ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div data-slot="dialog-footer" className={`fm-shadcn-dialog-footer ${className}`.trim()} {...props} />;
}

/** 对话框可访问性标题。 */
export function DialogTitle({ className = "", ...props }: ComponentProps<typeof DialogPrimitive.Title>) {
  return <DialogPrimitive.Title data-slot="dialog-title" className={`fm-shadcn-dialog-title ${className}`.trim()} {...props} />;
}

/** 对话框辅助说明。 */
export function DialogDescription({ className = "", ...props }: ComponentProps<typeof DialogPrimitive.Description>) {
  return <DialogPrimitive.Description data-slot="dialog-description" className={`fm-shadcn-dialog-description ${className}`.trim()} {...props} />;
}
